::ng-deep app-state-selector-cell-editor mat-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix mat-chip-listbox input{padding-inline:8px 0}
/*# sourceMappingURL=state-selector-cell-editor.component-WQABFIXT.css.map */
